import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Transition } from '@headlessui/react';
import { useEffect, useRef, useState } from 'react';
import { Notification, } from './notification.component';
const ANIMATION_DURATION = 300;
export const ToastNotification = (_a) => {
    var { timeout, onClose, position = 'bottom-start' } = _a, props = __rest(_a, ["timeout", "onClose", "position"]);
    const [isShowing, setIsShowing] = useState(true);
    const animationTimeout = useRef();
    useEffect(() => {
        return () => {
            if (animationTimeout.current) {
                clearTimeout(animationTimeout.current);
            }
        };
    }, []);
    useEffect(() => {
        let timer;
        if (timeout && timeout > 0 && props.type !== 'error') {
            timer = setTimeout(() => {
                handleCloseToast();
            }, timeout);
        }
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [timeout, props.type]);
    const handleCloseToast = () => {
        setIsShowing(false);
        animationTimeout.current = setTimeout(() => {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            animationTimeout.current = undefined;
        }, ANIMATION_DURATION);
    };
    return (_jsx(Transition, { appear: true, show: isShowing, enter: 'nucleus-transition-all nucleus-ease-in nucleus-duration-300', enterFrom: `nucleus-opacity-0 ${position.includes('bottom') ? 'nucleus-translate-y-6' : '-nucleus-translate-y-6'}`, leave: 'nucleus-transition-all nucleus-ease-out nucleus-duration-300', leaveTo: `nucleus-opacity-0 ${position.includes('end') ? 'nucleus-translate-x-12' : '-nucleus-translate-x-12'}`, children: _jsx(Notification, Object.assign({}, props, { onClose: handleCloseToast, variant: 'toast', closeable: true })) }));
};
//# sourceMappingURL=notification_toast.component.js.map